module.exports = __webpack_public_path__ + "img/dice-logo1.2ae98d43.svg";